import type HttpClient from "../../tastyworks/http"
import type { JsonHelper } from "../../tastyworks/util/json"

export class OrderService {
  constructor(private readonly accountNumberClient: HttpClient) {}

  readonly create = async (
    accountNumber: string,
    payload: Record<string, unknown>
  ): Promise<JsonHelper> =>
    this.accountNumberClient.postJson("orders", payload, {
      accountNumber,
    })

  readonly dryRun = async (
    accountNumber: string,
    payload: Record<string, unknown>
  ): Promise<JsonHelper> =>
    this.accountNumberClient.postJson("orders/dry-run", payload, {
      accountNumber,
    })
}
